import React from 'react'

export const ReportSignatureView = ({signature, responsible, getResource}) => (
  <div className="signature-content">
    {responsible.structure === 'digitally-signed' &&
    <div className="signature-image wait-background-image"
         style={{backgroundImage: 'url("' + getResource(signature.digitalSignature) + '")'}}/>}
    {responsible.structure !== 'name-only' && <div className="signature-line"/>}
    <div className="signature-name">{signature.name}</div>
    <div className="signature-description"
         dangerouslySetInnerHTML={{__html: signature.description.replace(/\n/g, '<br/>')}}/>
  </div>
)
